import { cn } from '@/lib/cn';

export interface BetslipTotalsProps {
  maxOdds: string;
  possibleWin: string;
  className?: string;
}

/** Figma BetslipTotals — max. odds and possible win. */
export function BetslipTotals({ maxOdds, possibleWin, className }: BetslipTotalsProps) {
  return (
    <dl className={cn('flex w-full flex-col gap-1 text-[13px]', className)}>
      <div className="flex h-[18px] items-center justify-between gap-2">
        <dt className="text-text-secondary">max. odds</dt>
        <dd className="font-bold tabular-nums text-text-primary">{maxOdds}</dd>
      </div>
      <div className="flex h-[18px] items-center justify-between gap-2">
        <dt className="text-text-secondary">possible win</dt>
        <dd className="font-bold tabular-nums text-text-primary">{possibleWin}</dd>
      </div>
    </dl>
  );
}
